import LogoLoader from './logo-loader';

export * from './logo-loader';

export default LogoLoader;
